// Importe en letras para la factura (art. 11 del Reglamento de Facturación):
// 1250.5 → "UN MIL DOSCIENTOS CINCUENTA LEMPIRAS CON 50/100".
const UNIDADES = ['', 'UNO', 'DOS', 'TRES', 'CUATRO', 'CINCO', 'SEIS', 'SIETE', 'OCHO', 'NUEVE',
  'DIEZ', 'ONCE', 'DOCE', 'TRECE', 'CATORCE', 'QUINCE', 'DIECISÉIS', 'DIECISIETE', 'DIECIOCHO', 'DIECINUEVE',
  'VEINTE', 'VEINTIUNO', 'VEINTIDÓS', 'VEINTITRÉS', 'VEINTICUATRO', 'VEINTICINCO', 'VEINTISÉIS', 'VEINTISIETE', 'VEINTIOCHO', 'VEINTINUEVE'];
const DECENAS = ['', '', '', 'TREINTA', 'CUARENTA', 'CINCUENTA', 'SESENTA', 'SETENTA', 'OCHENTA', 'NOVENTA'];
const CENTENAS = ['', 'CIENTO', 'DOSCIENTOS', 'TRESCIENTOS', 'CUATROCIENTOS', 'QUINIENTOS', 'SEISCIENTOS', 'SETECIENTOS', 'OCHOCIENTOS', 'NOVECIENTOS'];

function menorDeMil(n) {
  if (n === 0) return '';
  if (n === 100) return 'CIEN';
  const c = Math.floor(n / 100);
  const resto = n % 100;
  let texto = CENTENAS[c];
  if (resto) {
    const parte = resto < 30 ? UNIDADES[resto]
      : DECENAS[Math.floor(resto / 10)] + (resto % 10 ? ` Y ${UNIDADES[resto % 10]}` : '');
    texto = texto ? `${texto} ${parte}` : parte;
  }
  return texto;
}

// 'VEINTIUNO' → 'VEINTIÚN', 'UNO' → 'UN' (delante de MIL o de LEMPIRAS).
const apocopar = (t) => t.replace(/VEINTIUNO$/, 'VEINTIÚN').replace(/UNO$/, 'UN');

function entero(n) {
  if (n === 0) return 'CERO';
  const millones = Math.floor(n / 1000000);
  const miles = Math.floor((n % 1000000) / 1000);
  const resto = n % 1000;
  const partes = [];
  if (millones) partes.push(millones === 1 ? 'UN MILLÓN' : `${apocopar(entero(millones))} MILLONES`);
  if (miles) partes.push(`${apocopar(menorDeMil(miles))} MIL`);
  if (resto) partes.push(menorDeMil(resto));
  return partes.join(' ');
}

export function lempirasEnLetras(monto) {
  const centavosTotales = Math.round(Math.abs(Number(monto) || 0) * 100);
  const enteros = Math.floor(centavosTotales / 100);
  const centavos = centavosTotales % 100;
  const palabra = enteros === 1 ? 'LEMPIRA' : 'LEMPIRAS';
  const de = enteros >= 1000000 && enteros % 1000000 === 0 ? ' DE' : '';
  return `${apocopar(entero(enteros))}${de} ${palabra} CON ${String(centavos).padStart(2, '0')}/100`;
}
